import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, map, Observable } from 'rxjs';
import { getApiUrl, apiList } from '../Constants/apiList';
import { UserDetails, UserProfile } from '../Models/interfaces/user-details';
import { UtilityService } from './utility.service';
import { ApiResponse } from '../Models/interfaces/responseData';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  public userProfile!: UserProfile | null;
  private isAuthenticatedSubject$ = new BehaviorSubject<boolean>(false);
  public isAuthenticated$ = this.isAuthenticatedSubject$.asObservable();
  isDoneLoading$: string ='';

  constructor(
    private utility: UtilityService,
    private http: HttpClient
  ) { }
  public getUserInfo(reFetch: boolean = false): UserProfile | null {
    if (reFetch) this.userProfile = null;
    try {
      if (!this.userProfile) {
        let profile = this.utility.getFromLocalStorage('profile');
        this.userProfile = profile ? JSON.parse(profile) : null;
      }
    } catch (err) {
      // console.error('Something went wrong with storage!');
    }
    return this.userProfile;
  }
  public setUserInfo(userInfo: UserProfile) {
    this.userProfile = userInfo;
    this.utility.saveToLocalStorage('profile', JSON.stringify(userInfo));
  }
  get isAuthenticated() {
    let userInfo = this.getUserInfo();
    return (userInfo?.accessToken && userInfo?.refreshToken && userInfo?.userDetails)
  }
  refreshToken(): Observable<ApiResponse> {

    let payload = this.userProfile?.refreshToken

    let endpoint = getApiUrl(apiList.refreshToken.refresh_token, null);
    return this.http.post<ApiResponse>(endpoint, { refresh_token: payload })
  }

  getPermissions(perName: string): boolean {
    // let permissionName = this.userProfile?.userDetails?.permissions;
    let permissions = this.userProfile?.userDetails?.permissions;
    if (permissions?.length) {
      permissions = permissions.map(str => str.toLowerCase().trim());
      return permissions.some(per => per === perName.toLowerCase().trim());
    } else {
      return false;
    }
  }

}
